import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { store } from "../../store";
import * as actions from "../../store/actions";
import { Salesarea } from "../../../../../appv5/src/types/shared/Salesarea";

export function useSwitchToSalesarea(vestiging: Salesarea) {
  const dispatch = useDispatch();

  useEffect(() => {
    if (vestiging?.id && vestiging?.naam) {
      const data = store.getState();
      const filters = data["filtersV2"];

      if (
        !("vestiging_id" in filters) ||
        ("vestiging_id" in filters && filters?.["vestiging_id"]?.value !== vestiging.id)
      ) {
        dispatch({
          type: actions.SET_FILTER,
          payload: {
            key: "vestiging_id",
            filter: {
              field: "vestiging_id",
              operator: "=",
              value: vestiging.id,
              label: vestiging.naam,
              appTarget: vestiging?.appTarget,
            },
          },
        });
      }
    }
  }, [vestiging]);
}
